<template>
  <div class="spoiler" :class="{'spoiler--active': shown}">
    <h2 class="spoiler__title" @click="toggle">{{ title }}</h2>
    <span class="spoiler__indicator">
      <i class="fas fa-chevron-down"></i>
    </span>
    <div class="spoiler__content" ref="content" :style="{'max-height': shown ? `${maxHeight}px` : 0}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'spoiler',
  data() {
    return {
      shown: true,
      maxHeight: 100,
    }
  },
  props: {
    title: String,
    disabled: Boolean
  },
  methods: {
    toggle() {
      this.shown = !this.shown
    },
    setMaxHeight() {
      this.maxHeight = this.$refs.content.scrollHeight + 300
    }
  },
  mounted() {
    this.shown = !this.disabled
    this.setMaxHeight()

    this.$on('update', () => {
      this.setMaxHeight()
    })
  }
}
</script>

<style lang="scss" scoped>
  .spoiler {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    margin-top: 12px;

    $border-radius: 16px;

    &__title {
      font-weight: 300;
      font-size: 1rem;
      text-align: center;
      background-color: lighten($primaryColor, 26);
      padding: 8px;
      margin: 0;
      border-radius: $border-radius;
      cursor: pointer;
      transition: 0.3s;
    }

    &__indicator {
      display: block;
      position: absolute;
      top: 8px;
      right: 12px;
      padding: 4px;
      color: #333;
      cursor: pointer;
      font-size: 0.8em;
      transition: 0.3s;
      pointer-events: none;
    }

    &__content {
      border: dotted 1px transparent;
      border-top: 0;
      padding: 0 12px;
      overflow: hidden;
      max-height: 0;
      transition: all 0.3s;
      border-bottom-left-radius: $border-radius;
      border-bottom-right-radius: $border-radius;
    }

    &--active &__title {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    &--active &__indicator {
      transform: rotate(180deg);
      top: 6px;
    }

    &--active &__content {
      padding: 6px 12px;
      border-color: #eee;
    }
  }
</style>

